export enum resetTypes {
  FETCH_RESET_REQUEST = "FETCH_RESET_REQUEST",
  FETCH_RESET_SUCCESS = "FETCH_RESET_SUCCESS",
  FETCH_RESET_FAILURE = "FETCH_RESET_FAILURE",
}